const path = require('path');
const contentPath = require('@truqc/content-path');
const momentTimezone = require('moment-timezone');
const lodash = require('lodash');
const sparkMD5 = require('spark-md5');
const {
  uuid,
  uuidV5
} = require('./common');
module.exports = {
  'content-path': contentPath,
  lodash,
  moment: momentTimezone,
  'moment-timezone': momentTimezone,
  path,
  'spark-md5': sparkMD5,
  uuid: {
    v4: uuid,
    v5: uuidV5
  }
};